import React from 'react';
import { Button } from './ui/button';
import { clothingData } from '../mockData';
import { ShoppingBag } from 'lucide-react';

const ClothingSection = () => {
  return (
    <section id="shop-brand" data-testid="clothing-section" className="py-16 sm:py-14 sm:py-16 lg:py-20 lg:py-24 bg-neutral-950 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={clothingData.image} 
          alt="Dillon Blueprint Apparel"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/70"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="inline-block p-4 bg-neutral-900 rounded-full mb-4">
            <ShoppingBag className="w-12 h-12 text-gray-400" />
          </div>
          
          <h2 className="text-4xl md:text-6xl font-black text-white">
            {clothingData.title}
          </h2>
          
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {clothingData.description}
          </p>

          {/* CTA Button */}
          <div className="pt-8">
            <Button 
              onClick={() => window.open(clothingData.shopLink, '_blank')}
              className="bg-gray-400 hover:bg-gray-500 text-black font-bold px-12 py-6 text-xl transition-all hover:scale-105"
            >
              {clothingData.cta}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClothingSection;
